import {createStrokeSVG} from './TEMPLATE'

// tabler: stack-2
export const StarterPack = createStrokeSVG({
  paths: ['M12 4l-8 4l8 4l8 -4l-8 -4', 'M4 12l8 4l8 -4', 'M4 16l8 4l8 -4'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
